import { createContext, MouseEvent } from 'react'
import { MCOnboarding } from 'src/interfaces/mcOnboarding'
import { defaultColumnManagerContext, IColumnManagerContext } from 'src/interfaces/columnManager'

export interface IMCOnboardingsTableContext extends IColumnManagerContext {
  refreshOnboardings(): void

  // edit action
  actionAnchor: null | HTMLElement
  onboardingToAction: MCOnboarding | null
  openOnboardingsItemAction(event: MouseEvent<HTMLButtonElement>, onboarding: MCOnboarding): void
  closeOnboardingsItemAction(): void
}

export const MCOnboardingsTableContext = createContext<IMCOnboardingsTableContext>({
  ...defaultColumnManagerContext,

  refreshOnboardings: () => {},

  actionAnchor: null,
  onboardingToAction: null,
  openOnboardingsItemAction: () => {},
  closeOnboardingsItemAction: () => {},
})
